import { useState, useRef } from "react";
import quotation from "../../assets/icons/quotation.png";
import DefaultPatient from "../../assets/images/images/DefaultPatient.jpg";

export default function Testimonials() {
  const [active, setActive] = useState(2);
  const startX = useRef(0);

  const testimonials = [
    {
      name: "Ananya S",
      role: "Patient",
      image: DefaultPatient,
      text: "Booking an appointment was super easy and convenient. Loved the quick response from the doctor!",
    },
    {
      name: "Rohan K",
      role: "Patient",
      image: DefaultPatient,
      text: "I got my consultation done in under 30 minutes. The doctor was very professional and helpful.",
    },
    {
      name: "Meera P",
      role: "Patient",
      image: DefaultPatient,
      text: "The app interface is very user-friendly, and scheduling appointments is a breeze.",
    },
    {
      name: "Arjun M",
      role: "Patient",
      image: DefaultPatient,
      text: "Had a great experience! The video call feature works flawlessly and saved me a trip to the clinic.",
    },
    {
      name: "Sanya R",
      role: "Patient",
      image: DefaultPatient,
      text: "Highly recommend! Quick booking, great support, and very professional doctors.",
    },
  ];

  const total = testimonials.length;

  const next = () => setActive((p) => (p + 1) % total);
  const prev = () => setActive((p) => (p - 1 + total) % total);

  const handleStart = (e) => {
    startX.current = e.touches ? e.touches[0].clientX : e.clientX;
  };

  const handleEnd = (e) => {
    const end = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
    const diff = end - startX.current;

    if (diff < -60) next();
    if (diff > 60) prev();
  };

  return (
    <div
      style={{
        position: "relative",
        top: "30px",
        height: "450px",
        width: "100%",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingBottom: "20px",
      }}
      onMouseDown={handleStart}
      onMouseUp={handleEnd}
      onTouchStart={handleStart}
      onTouchEnd={handleEnd}
    >
      {testimonials.map((t, i) => {
        let pos = i - active;

        const CARD_WIDTH = 405;
        const GAP = 40;
        if (pos > 2) pos -= total;
        if (pos < -2) pos += total;

        if (Math.abs(pos) > 2) return null;

        const x = pos * (CARD_WIDTH + GAP);
        const y = Math.pow(pos, 2) * 45;
        const rotate = pos * 7;
        const scale = 1;

        return (
          <div
            key={i}
            onClick={() => setActive(i)}
            style={{
              position: "absolute",
              width: `${CARD_WIDTH}px`,
              height: "356px",
              padding: "24px",
              background: "#fff",
              borderRadius: "20px",
              border: "1px solid #c084fc",
              boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              transform: `translate(${x}px, ${y}px) rotate(${rotate}deg) scale(${scale})`,
              transition: "transform .5s ease",
              zIndex: 10 - Math.abs(pos),
              cursor: "pointer",
            }}
          >
            <div style={{ fontSize: "40px", color: "#c084fc" }}>
              <img src={quotation} alt="quotation" className="w-12 h-12" />
            </div>

            <p style={{ color: "#555", marginTop: "20px", fontSize: "20px" }}>
              {t.text}
            </p>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "40px",
              }}
            >
              <img
                src={t.image}
                alt=""
                style={{
                  width: "76px",
                  height: "76px",
                  borderRadius: "50%",
                  marginRight: "10px",
                }}
              />

              <div>
                <div style={{ fontWeight: 600, fontSize: "20px" }}>
                  {t.name}
                </div>
                <div style={{ color: "#a855f7", fontSize: "14px" }}>
                  {t.role}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
